// TODO: Move Urls to Azure Key Vault
export const DOT_DIGITAL_API_URL =
    'https://scun3crk1dh45262502-rs.su.retail.dynamics.com/Commerce/VSICreateOrUpdateDotDigitalContact?api-version=7.3';
